import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AuthSimpleLayout from '../layouts/AuthSimpleLayout';
import MainLayout from '../layouts/MainLayout';

import ErrorLayout from '../layouts/ErrorLayout';
import WizardAuth from 'components/authentication/wizard/WizardAuth';
import Landing from 'components/pages/landing/Landing';

import Accordion from 'components/doc-components/Accordion';
import Alerts from 'components/doc-components/Alerts';
import Badges from 'components/doc-components/Badges';
import Breadcrumbs from 'components/doc-components/Breadcrumb';
import Buttons from 'components/doc-components/Buttons';
import CalendarExample from 'components/doc-components/CalendarExample';
import Cards from 'components/doc-components/Cards';
import Dropdowns from 'components/doc-components/Dropdowns';
import ListGroups from 'components/doc-components/ListGroups';
import Modals from 'components/doc-components/Modals';
import Offcanvas from 'components/doc-components/Offcanvas';
import Pagination from 'components/doc-components/Pagination';
import BasicProgressBar from 'components/doc-components/ProgressBar';
import Spinners from 'components/doc-components/Spinners';
import Toasts from 'components/doc-components/Toasts';
import Avatar from 'components/doc-components/Avatar';
import Image from 'components/doc-components/Image';
import Tooltips from 'components/doc-components/Tooltips';
import Popovers from 'components/doc-components/Popovers';
import Figures from 'components/doc-components/Figures';
import Hoverbox from 'components/doc-components/Hoverbox';
import Tables from 'components/doc-components/Tables';
import FormControl from 'components/doc-components/FormControl';
import InputGroup from 'components/doc-components/InputGroup';
import Select from 'components/doc-components/Select';
import Checks from 'components/doc-components/Checks';
import Range from 'components/doc-components/Range';
import FormLayout from 'components/doc-components/FormLayout';
import FloatingLabels from 'components/doc-components/FloatingLabels';
import FormValidation from 'components/doc-components/FormValidation';
import BootstrapCarousel from 'components/doc-components/BootstrapCarousel';
import SlickCarousel from 'components/doc-components/SlickCarousel';
import Navs from 'components/doc-components/Navs';
import Navbars from 'components/doc-components/Navbars';
import Tabs from 'components/doc-components/Tabs';
import Collapse from 'components/doc-components/Collapse';
import CountUp from 'components/doc-components/CountUp';
import Embed from 'components/doc-components/Embed';
import Background from 'components/doc-components/Backgrounds';
import Search from 'components/doc-components/Search';
import VerticalNavbar from 'components/doc-components/VerticalNavbar';
import NavBarTop from 'components/doc-components/NavBarTop';
import NavbarDoubleTop from 'components/doc-components/NavbarDoubleTop';
import ComboNavbar from 'components/doc-components/ComboNavbar';
import TypedText from 'components/doc-components/TypedText';
import FileUploader from 'components/doc-components/FileUploader';
import Borders from 'components/utilities/Borders';
import Colors from 'components/utilities/Colors';
import ColoredLinks from 'components/utilities/ColoredLinks';
import Display from 'components/utilities/Display';
import Visibility from 'components/utilities/Visibility';
import StretchedLink from 'components/utilities/StretchedLink';
import Float from 'components/utilities/Float';
import Position from 'components/utilities/Position';
import Spacing from 'components/utilities/Spacing';
import Sizing from 'components/utilities/Sizing';
import TextTruncation from 'components/utilities/TextTruncation';
import Typography from 'components/utilities/Typography';
import VerticalAlign from 'components/utilities/VerticalAlign';
import Flex from 'components/utilities/Flex';
import Grid from 'components/utilities/Grid';
import WizardForms from 'components/doc-components/WizardForms';
import GettingStarted from 'components/documentation/GettingStarted';
import Configuration from 'components/documentation/Configuration';
import DarkMode from 'components/documentation/DarkMode';
import Plugins from 'components/documentation/Plugins';
import Styling from 'components/documentation/Styling';
import DesignFile from 'components/documentation/DesignFile';
import Starter from 'components/pages/Starter';
import AnimatedIcons from 'components/doc-components/AnimatedIcons';
import DatePicker from 'components/doc-components/DatePicker';
import FontAwesome from 'components/doc-components/FontAwesome';
import Changelog from 'components/documentation/change-log/ChangeLog';
import Analytics from 'components/dashboards/analytics';
import Crm from 'components/dashboards/crm';
import Saas from 'components/dashboards/saas';
import Profile from 'components/pages/user/profile/Profile';
import Associations from 'components/pages/asscociations/Associations';
import Followers from 'components/app/social/followers/Followers';
import Notifications from 'components/app/social/notifications/Notifications';
import ActivityLog from 'components/app/social/activity-log/ActivityLog';
import UserSettings from 'components/pages/user/settings/Settings';
import Feed from 'components/app/social/feed/Feed';
import Placeholder from 'components/doc-components/Placeholder';
import Lightbox from 'components/doc-components/Lightbox';
import AdvanceTableExamples from 'components/doc-components/AdvanceTableExamples';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import Calendar from 'components/app/calendar/Calendar';
import FaqAlt from 'components/pages/faq/faq-alt/FaqAlt';
import FaqBasic from 'components/pages/faq/faq-basic/FaqBasic';
import FaqAccordion from 'components/pages/faq/faq-accordion/FaqAccordion';
import PrivacyPolicy from 'components/pages/miscellaneous/privacy-policy/PrivacyPolicy';

import InvitePeople from 'components/pages/miscellaneous/invite-people/InvitePeople';
import PricingDefault from 'components/pages/pricing/pricing-default/PricingDefault';
import PricingAlt from 'components/pages/pricing/pricing-alt/PricingAlt';
import Invoice2 from 'components/app/e-commerce/Invoice';
import Billing from 'components/app/e-commerce/billing/Billing';
import Checkout from 'components/app/e-commerce/checkout/Checkout';
import ShoppingCart2 from 'components/app/e-commerce/cart/ShoppingCart';
import CustomersDetails from 'components/app/e-commerce/customers-details/CustomersDetails';
import OrderDetails from 'components/app/e-commerce/orders/order-details/OrderDetails';
import Product from 'components/app/e-commerce/product/Products';
import ProductDetail from 'components/app/e-commerce/product/product-details/ProductDetails';
import Order from 'components/app/e-commerce/orders/order-list/Orders';
import Customers from 'components/app/e-commerce/customers/Customers';
import Courses from 'components/app/e-learning/course/Courses';
import CourseDetails from 'components/app/e-learning/course/course-details';
import CreateCourse from 'components/app/e-learning/course/create-a-course';
import TrainerProfile from 'components/app/e-learning/trainer-profile';
import StudentOverview from 'components/app/e-learning/student-overview';
import CreateEvent from 'components/app/events/create-an-event/CreateEvent';
import EventList from 'components/app/events/event-list/EventList';
import EventDetail from 'components/app/events/event-detail/EventDetail';
import EmailDetail from 'components/app/email/email-detail/EmailDetail';
import Compose from 'components/app/email/compose/Compose';
import Inbox from 'components/app/email/inbox/Inbox';
import Rating from 'components/doc-components/Rating';
import AdvanceSelect from 'components/doc-components/AdvanceSelect';
import Editor from 'components/doc-components/Editor';
import Chat from 'components/app/chat/Chat';
import Kanban from 'components/app/kanban/Kanban';
import DraggableExample from 'components/doc-components/DraggableExample';
import LineCharts from 'components/doc-components/charts-example/echarts/line-charts';
import BarCharts from 'components/doc-components/charts-example/echarts/bar-charts';
import CandlestickCharts from 'components/doc-components/charts-example/echarts/candlestick-charts';
import GeoMaps from 'components/doc-components/charts-example/echarts/geo-map';
import ScatterCharts from 'components/doc-components/charts-example/echarts/scatter-charts';
import PieCharts from 'components/doc-components/charts-example/echarts/pie-charts';
import RadarCharts from 'components/doc-components/charts-example/echarts/radar-charts/Index';
import HeatmapCharts from 'components/doc-components/charts-example/echarts/heatmap-chart';
import Chartjs from 'components/doc-components/charts-example/chartjs';
import D3js from 'components/doc-components/charts-example/d3';
import HowToUse from 'components/doc-components/charts-example/echarts/HowToUse';
import GoogleMapExample from 'components/doc-components/GoogleMapExample';
import LeafletMapExample from 'components/doc-components/LeafletMapExample';
import CookieNoticeExample from 'components/doc-components/CookieNoticeExample';
import Scrollbar from 'components/doc-components/Scrollbar';
import Scrollspy from 'components/doc-components/Scrollspy';
import ReactIcons from 'components/doc-components/ReactIcons';
import ReactPlayerExample from 'components/doc-components/ReactPlayerExample';
import EmojiMartExample from 'components/doc-components/EmojiMart';
import TreeviewExample from 'components/doc-components/TreeviewExample';
import Timeline from 'components/doc-components/Timeline';
import Widgets from 'widgets/Widgets';
import Ecommerce from 'components/dashboards/e-commerce';
import Lms from 'components/dashboards/lms';
import ProjectManagement from 'components/dashboards/project-management';

import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import SimpleLogin from 'components/authentication/simple/Login';
import SimpleLogout from 'components/authentication/simple/Logout';
import SimpleRegistration from 'components/authentication/simple/Registration';
import SimpleForgetPassword from 'components/authentication/simple/ForgetPassword';
import SimplePasswordReset from 'components/authentication/simple/PasswordReset';
import SimpleConfirmMail from 'components/authentication/simple/ConfirmMail';
import SimpleLockScreen from 'components/authentication/simple/LockScreen';

import CardLogin from 'components/authentication/card/Login';
import Logout from 'components/authentication/card/Logout';
import CardRegistration from 'components/authentication/card/Registration';
import CardForgetPassword from 'components/authentication/card/ForgetPassword';
import CardConfirmMail from 'components/authentication/card/ConfirmMail';
import CardPasswordReset from 'components/authentication/card/PasswordReset';
import CardLockScreen from 'components/authentication/card/LockScreen';

import SplitLogin from 'components/authentication/split/Login';
import SplitLogout from 'components/authentication/split/Logout';
import SplitRegistration from 'components/authentication/split/Registration';
import SplitForgetPassword from 'components/authentication/split/ForgetPassword';
import SplitPasswordReset from 'components/authentication/split/PasswordReset';
import SplitConfirmMail from 'components/authentication/split/ConfirmMail';
import SplitLockScreen from 'components/authentication/split/LockScreen';

import Wizard from 'components/wizard/Wizard';
import Dashboard from 'components/dashboards/default';
import Faq from 'components/documentation/Faq';

import SupportDesk from 'components/dashboards/support-desk';
import TableView from 'components/app/support-desk/tickets-layout/TableView';
import CardView from 'components/app/support-desk/tickets-layout/CardView';
import Contacts from 'components/app/support-desk/contacts/Contacts';
import ContactDetails from 'components/app/support-desk/contact-details/ContactDetails';
import TicketsPreview from 'components/app/support-desk/tickets-preview/TicketsPreview';
import QuickLinks from 'components/app/support-desk/quick-links/QuickLinks';
import Reports from 'components/app/support-desk/reports/Reports';
import InputMaskExample from 'components/doc-components/InputMaskExample';
import RangeSlider from 'components/doc-components/RangeSlider';
import Paths from 'components/modules/routes/Routes';
//import Settings from 'components/settings';
import RoutesApp from 'routes/RoutesApp';
//import Collaboration from 'components/modules/Contracts/create/types/Middleman';
//import Register from 'components/modules/company/register/Register';
import ProviderOrder from 'components/modules/orders';
import Orders from 'components/modules/orders/Orders';
import NewOrder from 'components/modules/orders/new/NewOrder';

import RoutesSettings from 'routes/RoutesSettings';
import RoutesAdmin from 'routes/RoutesAdmin';
import RoutesPublic from 'routes/RoutesPublic';
import Demands from 'components/modules/demands/Demands';
import FeedBlog from 'components/app/blog/FeedBlog';
import Privacy2Policy from 'components/pages/miscellaneous/privacy-policy-2/Privacy2Policy';
import Biografy from 'components/pages/biografy/Biografy';
//import CreateContract from 'components/modules/contracts/create/CreateContract';
import Analitycs from 'components/modules/users/analytics/Analitycs';
import ProfileCompany from 'components/modules/company/profile/index';
//import SettingsCompany from 'components/modules/company/settings/SettingsCompany';
import Persons from 'components/modules/person/PersonForm';

import CompanyAuth from 'components/authentication/company/CompanyAuth';

import UserProfile from 'components/modules/users/profile';
import UserSetting from 'components/modules/users/settings';

import Tarea from 'components/modules/person/Tarea';
import Main from 'components/modules/person/Main';
import List from 'components/modules/person/List';
import ProviderProject from 'components/modules/project';
import Projects from 'components/modules/project/Projects';
import NewProject from 'components/modules/project/new/NewProject';
import ProjectDetails from 'components/modules/project/details';
import ProviderCompany from 'components/modules/company';
import Company from 'components/modules/company/Company';
//import NewCompany from 'components/modules/company/new/NewCompany';
import ProviderContract from 'components/modules/contracts';
import NewContract from 'components/modules/contracts/new/NewContract';
import Contracts from 'components/modules/contracts/Contracts';
/* import Proyecto from 'components/modules/project/Proyecto';
import ProjectsAll from 'components/modules/project/allprojects/ProjectsAll';
import ProjectsMain from 'components/modules/project/allprojects/projectsMain'; */
import AllOrders from 'components/modules/orders/allorders/AllOrders';
import Layout from 'layouts/Layout';
import DetailsOrders from 'components/modules/orders/ordersDetails/DetailsOrders';
import LoanProvider from 'components/modules/loans';
import Loans from 'components/modules/loans/Loans';
import WhatsAppProvider from 'components/modules/whatsapp';
import WhatsApp from 'components/modules/whatsapp/WhatsApp';
import ProviderInput from 'components/modules/inputs';
import Inputs from 'components/modules/inputs/Inputs';
import ProviderPayment from 'components/modules/payments';
import Payments from 'components/modules/payments/Payments';
import Invoice from 'components/modules/payments/Invoice';
import QueryPayment from 'components/modules/payments/QueryPayment';
import Products from 'components/modules/product/Products';
import ProductDetails from 'components/modules/product/details/ProductDetails';
import CreateProduct from 'components/modules/product/create/AddProduct';
import Articles from 'components/modules/article/Articles';
import CreateArticle from 'components/modules/article/create/AddArticle';
import ProviderTelegram from 'components/modules/telegram';
import Telegram from 'components/modules/telegram/Telegram';
import NewP from 'components/modules/telegram/product/New';
import ChangeCompany from 'layouts/ChangeCompany';

import ShoppingCart from 'components/modules/cart/ShoppingCart';

// Urls prmitaidas sin estar logueado
export const urlsToCompare = [
 '/:company?/company/profile/:id?',
 '/:company?/user/profile/:id?',
 '/:company?/user/settings',
 '/:company?/project/details/:id/:business?/:user?',
 '/:company?/app/loans',
 '/:company?/app/whatsapp',
 '/:company?/pruebas/rutas',
 '/:company?/modal'
];

const FalconRoutes = () => {
 return (
  <Routes>
   <Route path="/:company?" exact element={<Navigate to="/landing" replace />} />

   <Route path="telegram" element={<ProviderTelegram />}>
    <Route index element={<Telegram />} />
    <Route path="newproduct" element={<NewP />} />
   </Route>

   {/*- ------------- ERROR ---------------------------  */}
   <Route element={<ErrorLayout />}>
    <Route path="errors/404" element={<Error404 />} />
    <Route path="errors/500" element={<Error500 />} />
   </Route>

   {/* <Route path="/project" element={<ProjectsMain />}>
    <Route path="allprojects" element={<ProjectsAll />} />
   </Route> */}

   <Route path="/orderdetails/:id?" element={<DetailsOrders />} />
   <Route path="/AllOrders" element={<AllOrders />} />

   <Route path="/change/:token?" element={<ChangeCompany />} />

   {/*- ------------- ALLS -------------------------  */}
   <Route element={<Layout />}>
    {/* <Route path="/project" element={<ProviderProject />}>
     <Route path="details/:id/:business?/:user?" element={<ProjectDetails />} />
    </Route> */}
   </Route>

   {/*- ------------- PUBLIC --------------------------  */}
   <Route path="/:company?" element={<RoutesPublic />}>
    <Route path="landing" element={<Landing />} />
    <Route path="privacy-policy2" element={<Privacy2Policy />} />
    <Route path="biografy" element={<Biografy />} />
    {/* <Route path="settings" element={<SettingsCompany />} /> */}
    <Route path="ej" element={<Main />}>
     <Route path="tarea" element={<Tarea />} />
     <Route path="list" element={<List />} />
    </Route>

    <Route path="person" element={<Persons />} />

    <Route path="Blog">
     <Route path="feed" element={<FeedBlog />} />
    </Route>
    {/*-------------------DEMAND-----------------------------*/}
    <Route path="demand/:company?" element={<Demands />} />
    {/*------------------------------------------------------*/}

    {/*- ------------- Authentication ---------------------------  */}
    <Route path="authentication">
     {/*- ------------- company ---------------------------  */}
     <Route path="company/register" element={<CompanyAuth />} />

     {/*- ------------- simple ---------------------------  */}
     <Route path="simple" element={<AuthSimpleLayout />}>
      <Route path="login" element={<SimpleLogin />} />
      <Route path="register/:token?" element={<SimpleRegistration />} />
      <Route path="logout" element={<SimpleLogout />} />
      <Route path="forgot-password" element={<SimpleForgetPassword />} />
      <Route path="reset-password/:token" element={<SimplePasswordReset />} />
      <Route path="confirm-mail" element={<SimpleConfirmMail />} />
      <Route path="lock-screen" element={<SimpleLockScreen />} />
     </Route>

     {/*- ------------- Card ---------------------------  */}
     <Route path="card">
      <Route path="login" element={<CardLogin />} />
      <Route path="register/:token?" element={<CardRegistration />} />
      <Route path="logout" element={<Logout />} />
      <Route path="forgot-password" element={<CardForgetPassword />} />
      <Route path="reset-password/:token" element={<CardPasswordReset />} />
      <Route path="confirm-mail" element={<CardConfirmMail />} />
      <Route path="lock-screen" element={<CardLockScreen />} />
     </Route>

     {/*- ------------- Split ---------------------------  */}
     <Route path="split">
      <Route path="login" element={<SplitLogin />} />
      <Route path="logout" element={<SplitLogout />} />
      <Route path="register/:token?" element={<SplitRegistration />} />
      <Route path="forgot-password" element={<SplitForgetPassword />} />
      <Route path="reset-password/:token" element={<SplitPasswordReset />} />
      <Route path="confirm-mail" element={<SplitConfirmMail />} />
      <Route path="lock-screen" element={<SplitLockScreen />} />
     </Route>

     <Route element={<WizardAuth />}>
      <Route path="wizard" element={<Wizard validation={true} />} />
     </Route>
    </Route>
   </Route>

   {/*- ------------- PRIVADE -------------------------  */}
   <Route path="/:company?" element={<MainLayout />}>
    {/************ ALLS *************/}
    <Route path="modal" element={<ModalAuth />} />
    <Route path="company/profile/:id?" element={<ProfileCompany />} />

    <Route path="pruebas">
     <Route path="rutas" element={<Starter />} />
    </Route>

    <Route path="user">
     <Route path="profile/:id?" element={<UserProfile />} />
     <Route path="settings" element={<UserSetting />} />
    </Route>

    <Route path="products">
     <Route index path=":productLayout?" element={<Products />} />
     <Route path="create" element={<CreateProduct />} />
     <Route path="details/:productId?" element={<ProductDetails />} />
    </Route>

    <Route path="articles">
     <Route index path=":articleLayout?" element={<Articles />} />
     <Route path="create" element={<CreateArticle />} />
     <Route path="edit/:code?" element={<CreateArticle />} />
    </Route>

    <Route path="project" element={<ProviderProject />}>
     <Route path="details/:id/:user?" element={<ProjectDetails />} />
    </Route>

    <Route path="payments" element={<ProviderPayment />}>
     <Route index element={<QueryPayment />} />
     <Route path="contract/:id" element={<Payments />} />
     <Route path="invoice/:id?" element={<Invoice />} />
    </Route>

    <Route path="shopping-cart" element={<ShoppingCart />} />

    {/************ APP *************/}
    <Route path="app" element={<RoutesApp />}>
     <Route path="calendar" element={<Calendar />} />

     <Route path="whatsapp" element={<WhatsAppProvider />}>
      <Route index element={<WhatsApp />} />
      <Route path="new" element={<NewContract />} />
     </Route>

     <Route path="loans" element={<LoanProvider />}>
      <Route index element={<Loans />} />
      <Route path="new" element={<NewContract />} />
     </Route>

     <Route path="orders" element={<ProviderOrder />}>
      <Route index element={<Orders />} />
      <Route path="new/:projectId?" element={<NewOrder />} />
     </Route>

     <Route path="e-commerce">
      <Route path="orders">
       <Route path="order-details" element={<OrderDetails />} />
       <Route path="order-list" element={<Order />} />
      </Route>

      <Route path="invoice" element={<Invoice2 />} />
      <Route path="billing" element={<Billing />} />
      <Route path="checkout" element={<Checkout />} />
      <Route path="shopping-cart" element={<ShoppingCart2 />} />
      <Route path="customers" element={<Customers />} />
      <Route path="customer-details" element={<CustomersDetails />} />
      {/* Product */}
      <Route path="product">
       <Route path=":productLayout?" element={<Product />} />
       <Route path="product-details/:productId?" element={<ProductDetail />} />
      </Route>
     </Route>
     {/* E Learning */}
     <Route path="e-learning">
      <Route path="course">
       <Route path="course-details/:courseId?" element={<CourseDetails />} />
       <Route path=":courseLayout?" element={<Courses />} />
       <Route path="create-a-course" element={<CreateCourse />} />
      </Route>

      <Route path="trainer-profile" element={<TrainerProfile />} />
      <Route path="student-overview" element={<StudentOverview />} />
     </Route>
    </Route>

    {/* ******************SETTINGS*********************** */}
    <Route path="settings" element={<RoutesSettings />}>
     <Route path="demand" element={<Demands />} />

     <Route path="dashboard">
      <Route index element={<Dashboard />} />
      <Route path="analytics" element={<Analytics />} />
      <Route path="crm" element={<Crm />} />
      <Route path="saas" element={<Saas />} />
      <Route path="e-commerce" element={<Ecommerce />} />
      <Route path="lms" element={<Lms />} />
      {/* <Route path="create-contract" element={<CreateContract />} /> */}

      <Route path="project-management" element={<ProjectManagement />} />
      <Route path="support-desk" element={<SupportDesk />} />
     </Route>

     <Route path="projects" element={<ProviderProject />}>
      <Route index element={<Projects />} />
      <Route path="new" element={<NewProject />} />
     </Route>

     <Route path="inputs" element={<ProviderInput />}>
      <Route index element={<Inputs />} />
     </Route>

     <Route path="contracts" element={<ProviderContract />}>
      <Route index element={<Contracts />} />
      <Route path="create" element={<NewContract />} />
     </Route>

     <Route path="company" element={<ProviderCompany />}>
      <Route index element={<Company />} />
     </Route>

     <Route path="analytics/:user" element={<Analitycs />} />

     <Route path="routes">
      <Route index element={<Paths />} />
     </Route>
    </Route>

    {/* ************************ADMIN**************************** */}
    <Route path="admin" element={<RoutesAdmin />}>
     {/*Dashboard*/}
     <Route path="dashboard">
      <Route index element={<Dashboard />} />
      <Route path={'analytics'} element={<Analytics />} />
      <Route path="crm" element={<Crm />} />
      <Route path="saas" element={<Saas />} />
      <Route path="e-commerce" element={<Ecommerce />} />
      <Route path="lms" element={<Lms />} />
      <Route path="project-management" element={<ProjectManagement />} />
      <Route path="support-desk" element={<SupportDesk />} />
     </Route>

     {/*App*/}
     <Route path="app">
      <Route path="calendar" element={<Calendar />} />
      <Route path="chat" element={<Chat />} />
      <Route path="kanban" element={<Kanban />} />
      <Route path="social">
       <Route path="feed" element={<Feed />} />
       <Route path="activity-log" element={<ActivityLog />} />
       <Route path="notifications" element={<Notifications />} />
       <Route path="followers" element={<Followers />} />
      </Route>
      <Route path="events">
       <Route path="event-detail" element={<EventDetail />} />
       <Route path="create-an-event" element={<CreateEvent />} />
       <Route path="event-list" element={<EventList />} />
      </Route>

      {/* E Commerce */}
      <Route path="e-commerce">
       <Route path="orders">
        <Route path="order-details" element={<OrderDetails />} />
        <Route path="order-list" element={<Order />} />
       </Route>

       <Route path="invoice" element={<Invoice2 />} />
       <Route path="billing" element={<Billing />} />
       <Route path="checkout" element={<Checkout />} />
       <Route path="shopping-cart" element={<ShoppingCart2 />} />
       <Route path="customers" element={<Customers />} />
       <Route path="customer-details" element={<CustomersDetails />} />

       <Route path="product">
        <Route path="product-details" element={<ProductDetail />} />
        <Route path="product-details/:productId" element={<ProductDetail />} />
        <Route path=":productLayout" element={<Products />} />
       </Route>
      </Route>

      {/* E Learning */}
      <Route path="e-learning">
       <Route path="course" element={<Courses />} />
       <Route path="course/course-details/:courseId" element={<CourseDetails />} />
       <Route path="course/create-a-course" element={<CreateCourse />} />
       <Route path="trainer-profile" element={<TrainerProfile />} />
       <Route path="student-overview" element={<StudentOverview />} />
      </Route>

      {/* Email */}
      <Route path="email">
       <Route path="email-detail" element={<EmailDetail />} />
       <Route path="inbox" element={<Inbox />} />
       <Route path="compose" element={<Compose />} />
      </Route>

      {/* support desk */}
      <Route path="support-desk">
       <Route path="table-view" element={<TableView />} />
       <Route path="card-view" element={<CardView />} />
       <Route path="contacts" element={<Contacts />} />
       <Route path="contact-details" element={<ContactDetails />} />
       <Route path="tickets-preview" element={<TicketsPreview />} />
       <Route path="quick-links" element={<QuickLinks />} />
       <Route path="reports" element={<Reports />} />
       <Route path="tickets-preview" element={<TicketsPreview />} />
       <Route path="quick-links" element={<QuickLinks />} />
       <Route path="reports" element={<Reports />} />
      </Route>
     </Route>

     {/*Pages*/}
     <Route path="pages">
      <Route path="starter" element={<Starter />} />

      <Route path="landing" element={<Landing />} />
      <Route path="authentication">
       {/*- ------------- simple ---------------------------  */}
       <Route path="simple" element={<AuthSimpleLayout />}>
        <Route path="login" element={<SimpleLogin />} />
        <Route path="register" element={<SimpleRegistration />} />
        <Route path="logout" element={<SimpleLogout />} />
        <Route path="forgot-password" element={<SimpleForgetPassword />} />
        <Route path="reset-password" element={<SimplePasswordReset />} />
        <Route path="confirm-mail" element={<SimpleConfirmMail />} />
        <Route path="lock-screen" element={<SimpleLockScreen />} />
       </Route>

       {/*- ------------- Card ---------------------------  */}
       <Route path="card">
        <Route path="login" element={<CardLogin />} />
        <Route path="register" element={<CardRegistration />} />
        <Route path="logout" element={<Logout />} />
        <Route path="forgot-password" element={<CardForgetPassword />} />
        <Route path="reset-password/:token" element={<CardPasswordReset />} />
        <Route path="confirm-mail" element={<CardConfirmMail />} />
        <Route path="lock-screen" element={<CardLockScreen />} />
       </Route>

       {/*- ------------- Split ---------------------------  */}
       <Route path="split">
        <Route path="login" element={<SplitLogin />} />
        <Route path="logout" element={<SplitLogout />} />
        <Route path="register" element={<SplitRegistration />} />
        <Route path="forgot-password" element={<SplitForgetPassword />} />
        <Route path="reset-password" element={<SplitPasswordReset />} />
        <Route path="confirm-mail" element={<SplitConfirmMail />} />
        <Route path="lock-screen" element={<SplitLockScreen />} />
       </Route>

       <Route element={<WizardAuth />}>
        <Route path="wizard" element={<Wizard validation={true} />} />
       </Route>
       <Route path="modal" element={<ModalAuth />} />
      </Route>
      <Route path="user">
       <Route path="profile" element={<Profile />} />
       <Route path="settings" element={<UserSettings />} />
      </Route>
      <Route path="pricing">
       <Route path="pricing-default" element={<PricingDefault />} />
       <Route path="pricing-alt" element={<PricingAlt />} />
      </Route>
      <Route path="faq">
       <Route path="faq-alt" element={<FaqAlt />} />
       <Route path="faq-basic" element={<FaqBasic />} />
       <Route path="faq-accordion" element={<FaqAccordion />} />
      </Route>
      <Route path="miscellaneous">
       <Route path="associations" element={<Associations />} />
       <Route path="privacy-policy" element={<PrivacyPolicy />} />
       <Route path="invite-people" element={<InvitePeople />} />
      </Route>
     </Route>
     {/*Modules*/}
     <Route path="Modules">
      <Route path="forms">
       <Route path="basic">
        <Route path="form-control" element={<FormControl />} />
        <Route path="input-group" element={<InputGroup />} />
        <Route path="select" element={<Select />} />
        <Route path="checks" element={<Checks />} />
        <Route path="range" element={<Range />} />
        <Route path="layout" element={<FormLayout />} />
       </Route>
       <Route path="advance">
        <Route path="date-picker" element={<DatePicker />} />
        <Route path="editor" element={<Editor />} />
        <Route path="emoji-button" element={<EmojiMartExample />} />
        <Route path="advance-select" element={<AdvanceSelect />} />
        <Route path="file-uploader" element={<FileUploader />} />
        <Route path="rating" element={<Rating />} />
        <Route path="input-mask" element={<InputMaskExample />} />
        <Route path="range-slider" element={<RangeSlider />} />
       </Route>
       <Route path="floating-labels" element={<FloatingLabels />} />
       <Route path="validation" element={<FormValidation />} />
       <Route path="wizard" element={<WizardForms />} />
      </Route>
      <Route path="tables">
       <Route path="basic-tables" element={<Tables />} />
       <Route path="advance-tables" element={<AdvanceTableExamples />} />
      </Route>
      {/* charts-example */}
      <Route path="charts">
       <Route path="chartjs" element={<Chartjs />} />
       <Route path="d3js" element={<D3js />} />

       <Route path="echarts">
        <Route path="how-to-use" element={<HowToUse />} />
        <Route path="line-charts" element={<LineCharts />} />
        <Route path="bar-charts" element={<BarCharts />} />
        <Route path="geo-map" element={<GeoMaps />} />
        <Route path="scatter-charts" element={<ScatterCharts />} />
        <Route path="pie-charts" element={<PieCharts />} />
        <Route path="radar-charts" element={<RadarCharts />} />
        <Route path="heatmap-charts" element={<HeatmapCharts />} />
        <Route path="candlestick-charts" element={<CandlestickCharts />} />
       </Route>
      </Route>
      {/*icons*/}
      <Route path="icons">
       <Route path="font-awesome" element={<FontAwesome />} />
       <Route path="react-icons" element={<ReactIcons />} />
      </Route>

      {/* maps */}
      <Route path="maps">
       <Route path="google-map" element={<GoogleMapExample />} />
       <Route path="leaflet-map" element={<LeafletMapExample />} />
      </Route>

      {/* Components */}
      <Route path="components">
       <Route path="alerts" element={<Alerts />} />
       <Route path="accordion" element={<Accordion />} />
       <Route path="animated-icons" element={<AnimatedIcons />} />
       <Route path="background" element={<Background />} />
       <Route path="badges" element={<Badges />} />
       <Route path="breadcrumb" element={<Breadcrumbs />} />
       <Route path="buttons" element={<Buttons />} />
       <Route path="calendar" element={<CalendarExample />} />
       <Route path="cards" element={<Cards />} />
       <Route path="carousel">
        <Route path="bootstrap" element={<BootstrapCarousel />} />
        <Route path="slick" element={<SlickCarousel />} />
       </Route>
       <Route path="collapse" element={<Collapse />} />
       <Route path="cookie-notice" element={<CookieNoticeExample />} />
       <Route path="countup" element={<CountUp />} />
       <Route path="draggable" element={<DraggableExample />} />
       <Route path="dropdowns" element={<Dropdowns />} />
       <Route path="list-group" element={<ListGroups />} />
       <Route path="modals" element={<Modals />} />
       <Route path="offcanvas" element={<Offcanvas />} />
       <Route path="navs-and-tabs">
        <Route path="navs" element={<Navs />} />
        <Route path="navbar" element={<Navbars />} />
        <Route path="vertical-navbar" element={<VerticalNavbar />} />
        <Route path="top-navbar" element={<NavBarTop />} />
        <Route path="double-top-navbar" element={<NavbarDoubleTop />} />
        <Route path="combo-navbar" element={<ComboNavbar />} />
        <Route path="tabs" element={<Tabs />} />
       </Route>
       <Route path="pictures">
        <Route path="avatar" element={<Avatar />} />
        <Route path="images" element={<Image />} />
        <Route path="figures" element={<Figures />} />
        <Route path="hoverbox" element={<Hoverbox />} />
        <Route path="lightbox" element={<Lightbox />} />
       </Route>
       <Route path="progress-bar" element={<BasicProgressBar />} />
       <Route path="pagination" element={<Pagination />} />
       <Route path="placeholder" element={<Placeholder />} />
       <Route path="popovers" element={<Popovers />} />
       <Route path="scrollspy" element={<Scrollspy />} />
       <Route path="search" element={<Search />} />
       <Route path="spinners" element={<Spinners />} />
       <Route path="timeline" element={<Timeline />} />
       <Route path="toasts" element={<Toasts />} />
       <Route path="tooltips" element={<Tooltips />} />
       <Route path="treeview" element={<TreeviewExample />} />
       <Route path="typed-text" element={<TypedText />} />
       <Route path="videos">
        <Route path="embed" element={<Embed />} />
        <Route path="react-player" element={<ReactPlayerExample />} />
       </Route>
      </Route>

      {/*Utilities*/}
      <Route path="utilities">
       <Route path="borders" element={<Borders />} />
       <Route path="colors" element={<Colors />} />
       <Route path="colored-links" element={<ColoredLinks />} />
       <Route path="display" element={<Display />} />
       <Route path="visibility" element={<Visibility />} />
       <Route path="stretched-link" element={<StretchedLink />} />
       <Route path="stretched-link" element={<StretchedLink />} />
       <Route path="float" element={<Float />} />
       <Route path="position" element={<Position />} />
       <Route path="spacing" element={<Spacing />} />
       <Route path="sizing" element={<Sizing />} />
       <Route path="text-truncation" element={<TextTruncation />} />
       <Route path="typography" element={<Typography />} />
       <Route path="vertical-align" element={<VerticalAlign />} />
       <Route path="flex" element={<Flex />} />
       <Route path="grid" element={<Grid />} />
       <Route path="scroll-bar" element={<Scrollbar />} />
      </Route>
      {/*widgets*/}
      <Route path="widgets" element={<Widgets />} />
     </Route>
     {/*Documentation*/}
     <Route path="documentation">
      <Route path="getting-started" element={<GettingStarted />} />
      <Route path="customization">
       <Route path="configuration" element={<Configuration />} />
       <Route path="styling" element={<Styling />} />
       <Route path="dark-mode" element={<DarkMode />} />
       <Route path="plugin" element={<Plugins />} />
      </Route>
      <Route path="faq" element={<Faq />} />
      <Route path="design-file" element={<DesignFile />} />
      <Route path="changelog" element={<Changelog />} />
     </Route>
    </Route>
   </Route>

   {/* ************************ERROR**************************** */}
   <Route path="*" element={<Navigate to="/errors/404" replace />} />
  </Routes>
 );
};

export default FalconRoutes;
